export default function regulationsReducer(state = [], action) {
   const { type, regulationsData } = action
   switch (type) {
      case 'SET_ALL_REGULATIONS_LIST':
         return regulationsData
      default:
         return state
   }
}
